// extracted by mini-css-extract-plugin
module.exports = {"description":"SmartSalesPage-module__description___3RJ1A"};